exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-5afd6c09]{text-align:center}.notfound[data-v-5afd6c09]{font-size:8rem;color:#888}a[data-v-5afd6c09]{background:#036;padding:1rem 2rem;color:#fff;text-decoration:none;font-weight:700;border-radius:5px;display:block;max-width:220px;margin:2rem auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5afd6c09","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/NotFound.vue
// module id = 82
// module chunks = 0